<template>
  <div class="appPage">
    <navigation/>
    <router-view />
    <div class="bottomView">
      <div>—— 龙源版权确权平台 ——</div>
      <div>京ICP备10216796号-6</div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import Cookies from "js-cookie";
import navigation from "@/components/navigation.vue";
export default {
  name: "appPage",
  setup() {
    const store = useStore();
    const userInformation = Cookies.get('userInformation')
    if(userInformation){
      store.commit("isLoginSetting", false)
    }else{
      store.commit("isLoginSetting", true)
    }
  },
  components: {
    navigation,
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
  text-decoration: none;
  user-select: none;
}
.appPage {
  padding: 80px 0 0 0;
  box-sizing: border-box;
  .bottomView {
    // height: 50px;
    width: 100%;
    padding: 11px 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    // position: fixed;
    // left: 0;
    // bottom: 0;
    // z-index: 2;
    div {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
    }
  }
}

.mr-10{
  margin-right: 10px;
}
</style>
